export const CONFIG = {
  CHECKOUT_LINK_ESENCIAL:
    'https://checkout.ebookplanet.online/cart/46962131239100:1',
  CHECKOUT_LINK_COMPLETA:
    'https://checkout.ebookplanet.online/cart/46962131599548:1',
  META_PIXEL_ID: '1625572288540496',
  COUNTDOWN_MINUTES: 15,
}
